
import { ApiService } from "./apiService";

export const AboutService = function(){
    return {
        getAboutDatas:async()=>{
            const url = `/api/items/about?fields=*,translations.*,stats.*,stats.translations.*,features.*,features.translations.*,gallery.*,gallery.translations.*,gallery.images.directus_files_id,timeline.*,timeline.translations.*,video.*,video.translations.*`;
            const heroData = await ApiService.get(url);
            return heroData.data.data;
        }
    }
}

